import { combineReducers } from 'redux';
import { takeLatest, takeLeading } from 'redux-saga/effects';

import { ACLActionTypes, ACLState } from './ducks';
import { loadProductParamPrivilegeList, productParamPrivileges } from './productParamPrivileges/ducks';
import { loadProductPrivilegeList, productPrivileges } from './productPrivileges/ducks';
import {
  loadSimpleUserPrivilegeList,
  simpleUserPrivileges,
  simpleUserLoadingStatus,
} from './simpleUserPrivileges/ducks';
import { filterUserPrivilegeResourceList, userPrivilegeResources } from './userPrivilegeResources/ducks';
import { createActionType, RequestActionTypes } from 'helpers/redux/reduxHelpers';

/* REDUCERS */
export default combineReducers<ACLState>({
  simpleUserPrivileges,
  productPrivileges,
  productParamPrivileges,
  userPrivilegeResources,
  simpleUserLoadingStatus,
});

/* EXPORT */
export function* aclSaga() {
  yield takeLeading(
    createActionType(ACLActionTypes.LoadSimpleUserPrivilegeList, RequestActionTypes.REQUEST),
    loadSimpleUserPrivilegeList
  );

  yield takeLatest(
    createActionType(ACLActionTypes.LoadProductPrivilegeList, RequestActionTypes.REQUEST),
    loadProductPrivilegeList
  );

  yield takeLatest(
    createActionType(ACLActionTypes.LoadProductParamPrivilegeList, RequestActionTypes.REQUEST),
    loadProductParamPrivilegeList
  );

  yield takeLatest(
    createActionType(ACLActionTypes.FilterUserPrivilegeResourceList, RequestActionTypes.REQUEST),
    filterUserPrivilegeResourceList
  );
}
